import React from 'react'

import ActionsBox from '@/app/module/campaigns/component/actions/actions-box'
import { SMS_ACTION_DEFAULT_SENDERID } from '@/app/module/campaigns/definitions'
import { ChoiceListType, LocalAction, LocalOnAnswerType, RangeType } from '@/app/module/campaigns/types'
import { getActionOptionsForCampaign } from '@/app/module/campaigns/utils/actions/options'

import { ActionProps, ApiProps } from './part-config-props'
import ChoiceContainer from './question/choice/choice-container'
import InputChoice from './question/choice/input-choice'

type Props = {
  actionOptions: ReturnType<typeof getActionOptionsForCampaign>
  actionProps: ActionProps
  actions: LocalAction[]
  apiProps: ApiProps
  choiceIndex: number
  id: string
  isCloseDisabled: boolean
  label?: string
  ranges: RangeType[]
  replies: string[]

  onChange: (value: LocalOnAnswerType, index: number) => void
  onRemove: (index: number) => void
}

const ResponseSmsSpecificItem: React.FC<Props> = ({
  actionOptions,
  actionProps,
  actions,
  apiProps,
  choiceIndex,
  id,
  isCloseDisabled,
  label,
  ranges,
  replies,
  onChange,
  onRemove,
}) => {
  const handleActionsChange = React.useCallback(
    (actionsList: LocalAction[]) => {
      onChange(
        {
          ranges,
          replies,
          actions: actionsList,
          label,
        },
        choiceIndex,
      )
    },
    [choiceIndex, ranges, replies, label, onChange],
  )

  const handleLabelChange = React.useCallback(
    (newLabel: string) => {
      onChange(
        {
          ranges,
          replies,
          actions,
          label: newLabel,
        },
        choiceIndex,
      )
    },
    [choiceIndex, ranges, replies, actions, onChange],
  )

  const handleChoiceChange = React.useCallback(
    (value: ChoiceListType) => {
      onChange(
        {
          ranges: value.ranges || [],
          replies: value.replies || [],
          actions,
          label,
        },
        choiceIndex,
      )
    },
    [choiceIndex, actions, label, onChange],
  )
  const handleRemove = React.useCallback(() => onRemove(choiceIndex), [choiceIndex, onRemove])

  return (
    <ActionsBox
      key={`text-${choiceIndex}`}
      actionOptions={actionOptions}
      actions={actions}
      defaultSenderId={SMS_ACTION_DEFAULT_SENDERID.smsQuestion}
      hasTranscribe={false}
      imageId={`${id}-${choiceIndex}`}
      isCloseDisabled={isCloseDisabled}
      label={label}
      transcribeEnabled={false}
      updateContactConfig={{ invalid: false, openResponse: false, question: true }}
      voiceId={`${id}-${choiceIndex}`}
      onChange={handleActionsChange}
      onLabelChange={handleLabelChange}
      onClose={handleRemove}
      {...actionProps}
      {...apiProps}
    >
      <ChoiceContainer label="List of choices">
        <InputChoice tagList={{ ranges, replies }} onChange={handleChoiceChange} />
      </ChoiceContainer>
    </ActionsBox>
  )
}

export default React.memo(ResponseSmsSpecificItem)
